import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcSchedule20 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m10 2c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8zm0 2.01a5.979 5.979 0 0 0 -5.99 5.99 5.979 5.979 0 0 0 5.99 5.99 5.979 5.979 0 0 0 5.99-5.99 5.979 5.979 0 0 0 -5.99-5.99zm.995 1.99v3.59l2.186 2.186-1.405 1.405-2.771-2.771v-4.41z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcSchedule20;
